// extracted by mini-css-extract-plugin
export default {"tooltip":"info-tooltip_tooltip__RN08X"};